function updateLootcoinBalance(newLootcoinBalance) {
  return {
    type: 'LOOTCOIN_BALANCE_UPDATED',
    newLootcoinBalance,
  };
}

function updateLootgemBalance({ newLootgemBalance = 0 }) {
  return {
    type: 'LOOTGEM_BALANCE_UPDATED',
    newLootgemBalance,
  };
}

function updateTicketBalance({ newTicketBalance = 0 }) {
  return {
    type: 'TICKET_BALANCE_UPDATED',
    newTicketBalance,
  };
}

const isBalanceValid = (balance) => balance && typeof balance === 'number';

function updateBalance(
  dispatch,
  { newLootcoinBalance, newLootgemBalance, newTicketBalance },
) {
  if (isBalanceValid(newLootcoinBalance)) {
    dispatch(updateLootcoinBalance(newLootcoinBalance));
  }
  if (isBalanceValid(newLootgemBalance)) {
    dispatch(updateLootgemBalance({ newLootgemBalance }));
  }
  if (isBalanceValid(newTicketBalance)) {
    dispatch(updateTicketBalance({ newTicketBalance }));
  }
}

module.exports = {
  updateLootgemBalance,
  updateLootcoinBalance,
  updateTicketBalance,
  updateBalance,
};
